let router = [
                {
                    path: 'userInfo',
                    component: (resolve => {
                            require(["../header/user_info"], resolve)
                        }),
                    // components: {
                    //     top_head: (resolve => {
                    //         require(["../header/header_nav"], resolve)
                    //     }),
                    //     content: (resolve => {
                    //         require(["../function/page_group/outBox"], resolve)
                    //
                    //     }),
                    // },
                    // children: [{
                    //     path: '',
                    //     component: (resolve => {
                    //         require(["../header/user_info"], resolve)
                    //     }),
                    // },]
                }]
export default router